import { render } from "./QrPromtpay.vue?vue&type=template&id=d433eef4"
import script from "./QrPromtpay.vue?vue&type=script&lang=js"
export * from "./QrPromtpay.vue?vue&type=script&lang=js"
script.render = render

export default script